// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2o7jO","content":"styles_content__1AQK9","row":"styles_row__35hT9","footer":"styles_footer__13V0B","phraseLength":"styles_phraseLength__2QR3h"};